/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millSupportShaft.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation15.play();
    actions.Animation15.repetitions = 1;
    actions.Animation15.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="supportShaft" geometry={nodes.supportShaft.geometry} material={materials.軸灰} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millSupportShaft.glb')
